import React, { useEffect, useState } from 'react';

import { Outlet, useLocation } from 'react-router-dom';

import paths from '../../AppRouter/paths';
import colors from '../../assets/theme/colors';
import { useWindowSize } from '../../helpers/useWidth';
import VideoAdPage from '../../pages/VideoAd/VideoAdPage';
import ApplicationHeader from '../ApplicationHeader';
import Background from '../Background';
import HomeFooter from '../HomeFooter';
import SidebarLayout from '../SidebarLayout';

import Navigation from './Components/Navigation/Navigation';
import { StyledCOntainer, StyledMain } from './Layout.styles';
import SidebarBottom from './SidebarBottom';
import SidebarHeader from './SidebarHeader';
import { ILayoutProps } from './types';

const Layout: React.FC<ILayoutProps> = () => {
  const [isSidebarVisibleProp, setIsSidebarVisible] = useState(false);
  const { width } = useWindowSize();
  const isDesktop = width > 1250;
  const { pathname } = useLocation();

  const handleSidebarOpen = React.useCallback(
    () => setIsSidebarVisible(true),
    [setIsSidebarVisible],
  );

  const handleSidebarClose = React.useCallback(
    () => setIsSidebarVisible(false),
    [setIsSidebarVisible],
  );

  useEffect(() => {
    handleSidebarClose();
  }, [handleSidebarClose, pathname]);

  return (
    <>
      <VideoAdPage />
      <Background
        isVisible={isSidebarVisibleProp}
        onCloseClick={handleSidebarClose}
        style={{ background: `${colors.secondaryColor}` }}
      />
      <SidebarLayout
        BottomComponent={<SidebarBottom />}
        MiddleComponent={<Navigation />}
        TopComponent={<SidebarHeader />}
        isVisible={isSidebarVisibleProp}
      />
      <StyledCOntainer>
        {pathname !== paths.guide && !isDesktop ? (
          <ApplicationHeader
            onBurgerClick={handleSidebarOpen}
            votesAmount={0}
          />
        ) : (
          isDesktop && (
            <ApplicationHeader
              onBurgerClick={handleSidebarOpen}
              votesAmount={0}
            />
          )
        )}
        <StyledMain style={{ flex: 1 }}>
          <Outlet />
        </StyledMain>
        {pathname !== paths.guide && <HomeFooter />}
      </StyledCOntainer>
    </>
  );
};

export default Layout;
